<template>
    <div class="travel-insurance">
        <div class="travel-insurance__title-wrapper">
            <component
                :is="blok.HeroTitle?.[0]?.headingType ? blok.HeroTitle[0].headingType : 'h2'"
                class="travel-insurance__title"
            >
                {{ blok.HeroTitle?.[0]?.title }}
            </component>
        </div>
        <ul class="travel-insurance__features">
            <li v-for="point in blok.keySellingPoints" :key="point._uid" class="travel-insurance__feature">
                <NuxtIcon name="ri:check-fill" class="travel-insurance__feature-icon" size="16px" />
                <div v-html="renderRichText(point.content)"></div>
            </li>
        </ul>
        <div class="travel-insurance__brand">
            <span>{{ $t('searchWidget.travel-insurance.providedBy') }}</span>
            <img src="@nuxt-monorepo/ui/assets/images/battleface.png" alt="Battleface logo" loading="lazy" />
        </div>
        <a
            :href="blok.InsuranceLink.url"
            :target="blok.InsuranceLink.target"
            :rel="linkRel"
            class="travel-insurance__link"
        >
            <span>{{ $t('searchWidget.travel-insurance.buttonQuote') }}</span>
            <NuxtIcon name="ri:share-box-line" class="text-current -mt-0.5" size="20px" />
        </a>
    </div>
</template>

<script setup lang="ts">
import type { ITravelInsurance } from '@nuxt-monorepo/ui/types/components/TabbedSearchbox';

const { blok } = defineProps<ITravelInsurance>();

const linkRel = computed(() => (blok.InsuranceLink.target === '_blank' ? 'noopener noreferrer' : undefined));
</script>

<style scoped lang="postcss">
.travel-insurance {
    @apply p-6 gap-x-6 md:gap-y-3 grid-cols-2 flex flex-col md:grid;
    &__title-wrapper {
        grid-area: 1 / 1 / span 1 / span 1;
        @apply flex items-end justify-center mb-4 lg:mb-0;
    }
    &__title {
        max-width: 500px;
        @apply text-wl-base-dark font-bold text-xl leading-6 lg:text-[32px] lg:leading-[40px] text-center row-span-1 col-span-1;
    }
    &__brand {
        grid-area: 2 / 1 / span 1 / span 1;
        @apply flex items-center md:justify-center gap-1 mb-2 lg:mb-0;
        span {
            @apply text-xs text-wl-base-dark;
        }
        img {
            @apply block h-3;
        }
    }
    &__features {
        grid-area: 1 / 2 / span 1 / span 1;
        @apply flex flex-col gap-1 mb-4 lg:mb-0;
    }
    &__feature {
        @apply flex items-start gap-2 text-sm;
        &-icon {
            @apply text-wl-base-dark h-4 w-4 mt-0.5;
        }
    }
    &__link {
        @apply h-12 flex items-center justify-center gap-2 rounded-lg uppercase text-white text-base min-w-40 w-full font-bold transition-colors;
        span {
            @apply text-base font-bold uppercase;
            letter-spacing: 1px;
        }
    }
}
</style>
